import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

/** Hides storefront header/footer on admin; pads content under fixed header off-home. */
const StoreChrome: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  const isHome = pathname === '/';
  const isCheckout = pathname.startsWith('/checkout');

  return (
    <>
      {!isAdmin && <Header />}
      <main
        className={
          isAdmin || isCheckout
            ? 'min-h-screen'
            : isHome
              ? undefined
              : 'min-h-screen pt-[72px] lg:pt-[88px]'
        }
      >
        {children}
      </main>
      {!isAdmin && <Footer />}
    </>
  );
};

export default StoreChrome;
